import { Button, Group, List, Modal, Stack, Text } from '@mantine/core';

import { DeletionBlockedResponse } from '@/types';

interface DeleteScopeComponentModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  componentName: string;
  deletionBlocked: DeletionBlockedResponse | null;
}

export function DeleteScopeComponentModal({
  opened,
  onClose,
  onConfirm,
  componentName,
  deletionBlocked,
}: Readonly<DeleteScopeComponentModalProps>) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={deletionBlocked ? 'Cannot Delete Component' : 'Delete Component'}
      size="sm"
    >
      <Stack>
        {deletionBlocked ? (
          <>
            <Text>
              <Text span fw={700}>
                {componentName}
              </Text>{' '}
              cannot be deleted because it is currently in use.
            </Text>
            {deletionBlocked.referenced_by_configs.length > 0 && (
              <>
                <Text size="sm" fw={500}>
                  Referenced by report configurations:
                </Text>
                <List size="sm">
                  {deletionBlocked.referenced_by_configs.map((config) => (
                    <List.Item key={config.id}>{config.name}</List.Item>
                  ))}
                </List>
              </>
            )}
            {deletionBlocked.referenced_by_components.length > 0 && (
              <>
                <Text size="sm" fw={500}>
                  Referenced by other components:
                </Text>
                <List size="sm">
                  {deletionBlocked.referenced_by_components.map((comp) => (
                    <List.Item key={comp.slug}>{comp.name}</List.Item>
                  ))}
                </List>
              </>
            )}
            <Group justify="flex-end">
              <Button variant="default" onClick={onClose}>
                Close
              </Button>
            </Group>
          </>
        ) : (
          <>
            <Text>
              Are you sure you want to delete{' '}
              <Text span fw={700}>
                {componentName}
              </Text>
              ? This action cannot be undone.
            </Text>
            <Group justify="flex-end">
              <Button variant="default" onClick={onClose}>
                Cancel
              </Button>
              <Button color="red" onClick={onConfirm}>
                Delete
              </Button>
            </Group>
          </>
        )}
      </Stack>
    </Modal>
  );
}
